module.exports = __webpack_public_path__ + "static/tablet-bg-78045004c5d8e9d62abec75e30065d11.png";